(function(){
    angular
        .module('appback')
        .directive('ngGetbioquimica', nggetBioquimica);

        nggetBioquimica.$inject = ['$timeout','ResultadosService'];
        function nggetBioquimica($timeout,ResultadosService){
            return {
	            require: 'ngModel',
              	//templateUrl: '/backend/web/app/resultados/operacionmat.html',
              	//restrict: 'E',
	            scope: {
                  ngModel : '=',
                  item: '=',
                  analiticaid: '=',
                  subanalitica: '='
                  
              	},
	            link: function(scope, element, attrs, ngModel) {
	            	return $timeout(function(){
	            		//console.log("ngGetbio ",scope);
		            	if((!ngModel.$viewValue ||ngModel.$viewValue=='' || ngModel.$viewValue==0)){
		            		ResultadosService.getBioquimica(scope.item.peticion_id,scope.analiticaid,function(data){
		            			if(typeof(scope.subanalitica)!='undefined'){
		            				scope.subanalitica.dilucion = data.dilucion;
		            			}
		            			if(data.resultado){
		            				ngModel.$setViewValue(data.resultado);
	                				ngModel.$render();
			            		}
				            });
		            	}

	            	})
	            	
			      /*ngModel.$formatters.push(function(value) {
	            	console.log("tocecimal2");
			      	    return value ? parseFloat(value).toFixed(2).toString().replace(',', '.') : null;
			      });*/
				}
        	}
        }
})();